import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const KeyOutline = createIcon({
  displayName: 'KeyOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M15.031 9.342c0-.207-.168-.374-.375-.374 -.207.001-.375.169-.375.376 0 .207.168.375.375.374 .207 0 .375-.168.375-.375"></path>
        <path d="M3.5 17.195l5.723-5.736c-.806-2.094-.374-4.556 1.311-6.245 2.28-2.285 5.977-2.285 8.256 0 2.28 2.285 2.28 5.99 0 8.276 -1.701 1.705-4.189 2.134-6.291 1.296l-5.701 5.714h-3.298c0 0 0-3.305 0-3.305Z"></path>
      </g>
    </>
  ),
})

const KeyFilled = createIcon({
  displayName: 'KeyFilled',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" stroke="dark">
        <path
          fill="currentColor"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M3.5 17.195l5.723-5.736c-.806-2.094-.374-4.556 1.311-6.245 2.28-2.285 5.977-2.285 8.256 0 2.28 2.285 2.28 5.99 0 8.276 -1.701 1.705-4.189 2.134-6.291 1.296l-5.701 5.714h-3.298c0 0 0-3.305 0-3.305Z"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="1"
          d="M15.031 9.342c0-.207-.168-.374-.375-.374 -.207.001-.375.169-.375.376 0 .207.168.375.375.374 .207 0 .375-.168.375-.375"
        ></path>
      </Box>
    </>
  ),
})

const KeySimple: FC<CustomIconProps> = (props) => {
  if (props.variant === 'filled') {
    return <CustomIcon as={KeyFilled} {...props} />
  }
  return <CustomIcon as={KeyOutline} {...props} />
}

export default memo(KeySimple)
